export const config = {
    api_base: 'https://in-prod.diningtek.com/api/v1',
    api_root : 'https://in-prod.diningtek.com',
    api_account : 'https://in-account.diningtek.com',
    //api_root: 'https://testapi.diningtek.biz/api',
    token : localStorage.getItem("access_token"),
    user_id:localStorage.getItem("user_email"),
    mid:localStorage.getItem("mid"),
    permissionType: localStorage.getItem("permission_type")
};
